import { useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import "../styles/main.css";

function Navbar() {
	const navRef = useRef();

	const showNavbar = () => {
		navRef.current.classList.toggle(
			"responsive_nav"
		);
	};

	return (
		<header>
            <span className="logo">
           <img src={require('../images/logo.png')} alt='logo'/>
            <h3> Academify</h3>
            </span>
			
			<nav ref={navRef}>
				<a href="/">Home</a>
				<a href="/pastQuestion">Past Questions</a>
				<a href="/subject">Subjects</a>
				<a href="/about">About me</a>
				<button
					className="nav-btn nav-close-btn"
					onClick={showNavbar}>
					<FaTimes />
				</button>
			</nav>
			<button
				className="nav-btn"
				onClick={showNavbar}>
				<FaBars />
			</button>
		</header>
	);
}

export default Navbar;